import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GlobalState } from './global.state';

export const featureKey = 'global';

/**
 * Select the entire global state
 */
export const selectGlobalState = createFeatureSelector<GlobalState>(featureKey);

/**
 * Select the set of currently loading actions
 */
export const selectLoadingActions = createSelector(
    selectGlobalState,
    (state) => state.loadingActions
);

/**
 * Returns true if ANY action is currently loading
 * Use this for global loading indicators
 */
export const selectGlobalLoading = createSelector(
    selectLoadingActions,
    (loadingActions) => loadingActions.size > 0
);

/**
 * Returns the number of currently loading actions
 * Useful for debugging or showing multiple operation indicators
 */
export const selectLoadingCount = createSelector(
    selectLoadingActions,
    (loadingActions) => loadingActions.size
);

/**
 * Check if a specific action type is currently loading
 * 
 * @example
 * // In component
 * loadingRoads$ = this.store.select(selectIsLoadingAction('findRoads'));
 */
export const selectIsLoadingAction = (actionType: string | string[]) =>
    createSelector(selectLoadingActions, (loadingActions) => {
        if (Array.isArray(actionType)) {
            return actionType.some((type) => loadingActions.has(type));
        }
        return loadingActions.has(actionType);
    });

/**
 * Select the global error message
 */
export const selectGlobalError = createSelector(
    selectGlobalState,
    (state) => state.error
);

/**
 * Returns true if there is a global error
 */
export const selectHasGlobalError = createSelector(
    selectGlobalError,
    (error) => error !== null
);
